import { mixins, styled } from '@bob/library'

export const Title = styled.h2`
  ${mixins.typography.headlineMedium}
  ${mixins.media.max.height(871)} {
    ${mixins.typography.headlineSmall}
  }
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

export const Content = styled.div`
  max-width: 300px;
  width: 100%;
  display: flex;

  flex-direction: column;
  & > div:first-child {
    margin-top: 30px;
  }
  & > div:last-child {
    margin-bottom: 30px;
  }
`
